import { useQuery } from "@tanstack/react-query";
import client from "shared/utils/axios-config";
import { PaymentMethod } from "shared/types";

/* eslint-disable react-hooks/rules-of-hooks */
const getAllPaymentMethods = () => {
  return useQuery({
    queryKey: ["payment-methods"],
    queryFn: async (): Promise<PaymentMethod[] | undefined> => {
      const res = await client.get(`/v1/payment-methods`);
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
    staleTime: 5 * 60_000,
  });
};

export { getAllPaymentMethods };
